import { render, staticRenderFns } from "./dkOrder.vue?vue&type=template&id=5c16c28e&scoped=true&"
import script from "./dkOrder.vue?vue&type=script&lang=ts&"
export * from "./dkOrder.vue?vue&type=script&lang=ts&"
import style0 from "./dkOrder.vue?vue&type=style&index=0&id=5c16c28e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16c28e",
  null
  
)

export default component.exports